/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'
import React, { useState, useRef, useEffect } from 'react'
import { useLazyQuery, useSubscription } from '@apollo/client'

import { GET_COMMENTARY } from '@/graphql/match/match.query'
import { isBottomReached } from '@/shared/utils'
import Button from '../../button'
import Commentary from '../commentary'
import { GET_COMMENTARY_SUBSCRIPTION } from '@/graphql/match/match.subscription'
import NoData from '../../noData'
import commentaryVector from '../../../../assets/images/error-images/commentary.svg'
import CommentaryFilter from '../commentary/commentaryFilter'
import Loading from '../../loading'

type MatchDetailCommentaryProps = {
  data?: any
  matchDetail?: any
  handleCommentary?: () => void
}

const MatchDetailCommentary = ({ data, matchDetail }: MatchDetailCommentaryProps) => {
  const commentaryDetail = data?.listMatchCommentaries
  const btnDisabled = useRef(false)
  const loading = useRef(false)
  const lastData = useRef(0)

  const [commentaryData, setCommentaryData] = useState(commentaryDetail)
  const [enableBtn, setEnableBtn] = useState(commentaryDetail ? commentaryDetail?.length > 14 : false)
  const [isFilter, setIsFilter] = useState(false)
  const payloads = useRef<any>({
    iMatchId: matchDetail?._id,
    nLimit: 30,
    sEventId: '0',
    nInningNumber: null,
    sFilter: null
  })

  const [getMoreCommentary, { data: updatedCommentary, loading: apiLoading }] = useLazyQuery(GET_COMMENTARY, {
    fetchPolicy: 'network-only'
  })

  //! Function for update commentary data as per eOperationType
  function updateCommentary(d: any) {
    const newCommentaryData = [...commentaryData]
    //! update
    if (d?.eOperationType === 'update') {
      const index = newCommentaryData.findIndex((c: any) => c?._id === d?._id)
      if (index !== -1) {
        newCommentaryData[index] = { ...newCommentaryData[index], sComSummary: d.sComSummary, sCommentary: d.sCommentary }
      }
    }
    //!create
    else if (d?.eOperationType === 'create') {
      newCommentaryData.unshift(d)
    }
    //! delete
    else if (d?.eOperationType === 'delete') {
      const index = newCommentaryData.findIndex((c: any) => c?._id === d?._id)
      if (index !== -1) {
        newCommentaryData.splice(index, 1)
      }
    }

    // !if filter is not applied than push same data otherwise filter data
    if (payloads?.current?.sFilter === null && payloads?.current?.nInningNumber === null) {
      setCommentaryData(newCommentaryData)
    } else {
      filterSubscriptionData(newCommentaryData)
    }
  }

  useSubscription(GET_COMMENTARY_SUBSCRIPTION, {
    skip: typeof window === 'undefined',
    variables: { input: { iMatchId: matchDetail?._id } },
    onData: ({ data }) => {
      if (data?.data?.listMatchCommentariesV3) {
        updateCommentary(data?.data?.listMatchCommentariesV3)
      }
    }
  })

  // !load more comm>>>>>
  const handleLoadMore = () => {
    getMoreCommentary({ variables: { commentary: { ...payloads.current } } })
    setEnableBtn(false)
    btnDisabled.current = true
  }

  // !For infinite scrolling
  useEffect(() => {
    if (commentaryData?.length) {
      const lastItem = commentaryData[commentaryData?.length - 1]
      const id = `${commentaryData?.length - 1}-${lastItem?.sOver}-${lastItem?.nInningNumber}`
      payloads.current.sEventId = lastItem?.sEventId
      // payloads.current.nInningNumber = lastItem?.nInningNumber
      if (btnDisabled.current) {
        loading.current = false
        isBottomReached(id, isReached)
      }
    }
  }, [commentaryData])

  useEffect(() => {
    // !if filter is not applied than push prev data + current data otherwise current data
    if (isFilter) {
      setCommentaryData(updatedCommentary?.listMatchCommentaries)
      setIsFilter(false)
    } else {
      setCommentaryData([
        ...(commentaryData ? commentaryData : []),
        ...(updatedCommentary?.listMatchCommentaries
          ? // eslint-disable-next-line no-unsafe-optional-chaining
            updatedCommentary?.listMatchCommentaries
          : [])
      ])
      lastData.current = updatedCommentary?.listMatchCommentaries?.length
    }
  }, [updatedCommentary])

  async function isReached(reach: boolean) {
    if (reach && !loading.current && lastData.current > 14) {
      loading.current = true
      getMoreCommentary({ variables: { commentary: { ...payloads.current } } })
    }
  }

  // !Filter Data from subscription
  // ? [4, 6, W] => Highlight
  // ? [4, 6] => Boundary
  // ? [w] => Wicket
  // !-------------------
  function filterSubscriptionData(data: any) {
    const ing = payloads?.current?.nInningNumber
    let filteredData = data

    const allowedFilters = ['4', '6', 'w']

    // !Filter Type wise
    if (payloads?.current?.sFilter?.some((filter: any) => allowedFilters.includes(filter))) {
      if (payloads?.current?.sFilter[0] === '4') {
        filteredData = filteredData?.filter((d: any) => d?.sScore === '4' || d?.eEvent === 'ie')
      } else if (payloads?.current?.sFilter[0] === '6') {
        filteredData = filteredData?.filter((d: any) => d?.sScore === '6' || d?.eEvent === 'ie')
      } else if (payloads?.current?.sFilter[0] === 'w') {
        filteredData = filteredData?.filter((d: any) => d?.sScore === 'w' || d?.eEvent === 'ie')
      }
      setCommentaryData(filteredData)
    } else if (ing !== null) {
      const inningNumber = parseInt(ing, 10)
      filteredData = filteredData?.filter(
        (d: any) => d?.nInningNumber === inningNumber || (d?.eEvent === 'ie' && d?.nInningNumber === inningNumber)
      )
      setCommentaryData(filteredData)
    } else {
      setCommentaryData(data)
    }
  }

  //! Filter Commentary >>>>>>>>>>>>
  function filterCommentary(h: any, i: any) {
    setIsFilter(true)
    const newPayload = { ...payloads.current, sFilter: h, nInningNumber: i, sEventId: null }
    payloads.current.sFilter = h
    payloads.current.nInningNumber = i
    setEnableBtn(true)
    btnDisabled.current = false
    getMoreCommentary({ variables: { commentary: newPayload } })
  }

  return (
    <>
      {commentaryDetail?.length > 3 && <CommentaryFilter filterCommentary={filterCommentary} match={matchDetail} />}
      {commentaryData?.length !== 0 ? (
        <>
          {apiLoading && <Loading />}
          <Commentary data={commentaryData} inning={matchDetail?.aInning} />
          {/* {isCommentaryLoading && commentaryLoading()} */}
          {enableBtn && commentaryData?.length > 0 && (
            <div className='text-center my-3'>
              <Button className='' onClick={() => handleLoadMore()}>
                Load More
              </Button>
            </div>
          )}
        </>
      ) : (
        <div className='container'>
          <NoData imagePath={commentaryVector} />
        </div>
      )}
    </>
  )
}

export default MatchDetailCommentary
